export const PDC_CAB = "pdc";
export const POLICY_CODING = "coding";
export const POLICY_TRANSLATION = "translation";
export const POLICY_CONFIGURATION = "configuration";
export const POLICY_RELEASE = "release";

//from the PoetUserGroupAttribute table
export const USERGROUP_CODING_REVIEW = "Coding Review";
export const USERGROUP_TRANSLATION_REVIEW = "Translation Review";
export const USERGROUP_TRANSLATION = "Translation";
export const USERGROUP_CODING = "Coding";
export const POET_AVALON_POE = "POET-Avalon-POE";
export const POET_AVALON_CONFIGURATION = "Configuration";
export const POET_AVALON_CONFIGURATION_REVIEW = "Configuration Review";

//Workspace update constants
export const WORKSPACE_STATUS_TEXT_UPDATE = "UPDATED";
export const WORKSPACE_CLOB_KEY = "workspaceWithClob";

export const NEW_COMMENT = "NEW_COMMENT";

export const NOT_READY = "NOT_READY";
export const READY = "READY";
export const ALL = "ALL";
export const BUILD = "Build";
export const REGRESSION = "Regression";
export const UAT = "Release to UAT";
export const PREPROD = "Pre Prod Checkout";
export const PROD = "Release to Production";
export const DONE = "DONE";
export const IN_FLIGHT = "IN_FLIGHT";

//Policy types
export const P_TYPE_RTM = "RTM";
export const P_TYPE_PGTM = "P/GTM";
export const P_TYPE_SRX = "SRX";
export const P_TYPE_UNKNOWN = "Unknown";

export const StageFilterMap = {
  All: "All",
  "PDC/CAB": "PDC/CAB",
  Coding: "Coding",
  Translation: "Translation",
  Configuration: "Configuration",
};

export const quarterMapValues = () => {
  const month = new Date().getMonth() + 1;
  const currentQuarter = Math.ceil(month / 3);
  let year = new Date().getFullYear();
  return {
    All: "All", // Use a large year value to indicate "All"
    "Last Quarter":
      "Q" +
      (currentQuarter === 1 ? 4 : currentQuarter - 1) +
      "-" +
      (currentQuarter === 1 ? year - 1 : year),
    "This Quarter": "Q" + currentQuarter + "-" + year,
    "Next Quarter":
      "Q" +
      (currentQuarter === 4 ? 1 : currentQuarter + 1) +
      "-" +
      (currentQuarter === 4 ? year + 1 : year),
  };
};
//userActivity worthflows
export const WORKFLOW_CODING = "Coding";
export const WORKFLOW_TRANSLATION = "Translation";
export const WORKFLOW_CONFIGURATION = "Configuration";
export const WORKFLOW_HEALLTH_PLAN_CONFIGURATION = "Health Plan Configuration";
export const WORKFLOW_POLICY_CONFIGURATION = "Policy Configuration";
export const WORKFLOW_RELEASE_PLAN = "Release Plan";
export const WORKFLOW_RULE_BUILDER = "Rule Builder";
export const WORKFLOW_SAVE_ADOPTION_DECISION = "Save Adoption Decisions";
export const WORKFLOW_BULK_UPDATE = "Bulk Update";
